import {
  getTopDoctorsByLocationIdApi,
  getTopDoctorsByMedicineIdApi,
  getTopMedicinesByLocationIdApi
} from "./generalApi";

import { createAsyncThunk } from "@reduxjs/toolkit";

export const getTopDoctorsByMedicineId = createAsyncThunk(
  "medicine/get-top-doctor-by-medicineId",
  getTopDoctorsByMedicineIdApi
);

export const getTopDoctorsByLocationId = createAsyncThunk(
  "medicine/get-top-doctor-by-locationId",
  getTopDoctorsByLocationIdApi
);

export const getTopMedicinesByLocationId = createAsyncThunk(
  "medicine/get-top-medicine-by-locationId",
  getTopMedicinesByLocationIdApi
);